package com.parmartechnologies.core.feature.inventory.discount.network

import com.parmartechnologies.core.feature.inventory.discount.model.Discount
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class RetrieveDiscountResponse(
    @SerialName("status") val status: String,
    @SerialName("message") val message: String,
    @SerialName("payload") val payload: List<Discount>,
)


@Serializable
data class CreateDiscountResponse(
    @SerialName("status") val status: String,
    @SerialName("message") val message: String,
    @SerialName("payload") val payload: Discount?,
)

@Serializable
data class UpdateDiscountResponse(
    @SerialName("status") val status: String,
    @SerialName("message") val message: String,
    @SerialName("payload") val payload: Discount?,
)